import PropTypes from 'prop-types';
export const FormElementMode = PropTypes.oneOf(['view', 'edit']);
